import useTranslation from 'next-translate/useTranslation';

import { PopUpBase, Tabs } from '@/atoms';
import { BookingLavanda } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypePopUpBookingLavandaProps } from './types';

/**
 * PopUpBookingLavanda
 */
export const PopUpBookingLavanda: FunctionComponent<
  TypePopUpBookingLavandaProps
> = ({
  className = '',
  apartmentsByBuilding,
  buildings,
  onClose,
  show,
  province,
  defaultApartment,
  defaultBuilding,
}: TypePopUpBookingLavandaProps) => {
  const { t } = useTranslation('common');
  const isApartments = process.env.NEXT_PUBLIC_DOMAIN === 'apartments';
  const tabNames = [
    'Me quedo unos días',
    ...(isApartments ? ['Me quedo unos meses'] : []),
  ];
  return (
    <PopUpBase
      state={show}
      funcionOnClose={onClose}
      className={`${
        isApartments ? 'bg-surface-03' : 'bg-surface-01'
      } text-text-primary md:min-w-[500px] ${className}`}
      title={t('components.organisms.popUpBookingLavanda.title')}
    >
      <p className="text-body--primary mb-4 inline-block font-thin md:mb-6">
        {t('components.organisms.popUpBookingLavanda.description')}
      </p>

      <Tabs tabsName={tabNames} selectedAtFirst={0}>
        {tabNames.map((tab, index) => (
          <BookingLavanda
            key={index}
            className="!mt-20"
            buildings={buildings}
            apartmentsByBuilding={apartmentsByBuilding}
            defaultApartment={defaultApartment}
            defaultBuilding={defaultBuilding}
            province={province}
            isLongTerm={index === 1}
          />
        ))}
      </Tabs>
    </PopUpBase>
  );
};

PopUpBookingLavanda.displayName = 'PopUpBookingLavanda';
